export const checkCountOrStatusWasChange = (initialWork, changedWork, changedWorkStatusIsWithoutCount) => {
  const workStatusChanged = initialWork.status !== changedWork.status;

  if (changedWorkStatusIsWithoutCount) return workStatusChanged;
  return workStatusChanged || +initialWork.count !== changedWork.count;
};